import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createWidget } from 'actions/editor';
import { fetchComponentsForPalette } from 'actions/palette';

import _ from 'lodash';
import cx from 'classnames';
import { Tab } from 'react-bootstrap';
import { IKImage } from 'imagekitio-react';

import { PaletteContext } from '.';
import { getPositionForNewWidget } from 'components/Editor/helper/layoutManager';
import InfiniteScroll from "components/InfiniteScroll";

import {
  CAROUSEL, CAROUSEL_CARD
} from 'constants/widgetTypes';

import styles from './palette.module.scss';
import { WidgetPaletteFolders } from './multiWidgetFolderPalette';

export const CarouselPalette = ({ editorSession, defaultParent }) => {
  const paletteContext = React.useContext(PaletteContext);

  const { palettes = [] } = paletteContext;

  const paletteData = palettes.find(item => item.type === 'CAROUSELS');
  const defaultId = _.get(paletteData, 'defaultId', null);
  const brandkitId = _.get(paletteData, 'brandkitId', null);

  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const brandkitEnabled = _.get(workspace, 'brandkitEnabled', false);
  const showDefault = _.get(paletteData, 'showDefault', false) || !brandkitEnabled;


  return (
      <Tab.Pane eventKey="CAROUSELS" className={cx(styles.tabPane, styles.commonPalette)}>
        <WidgetPaletteFolders
          editorSession={editorSession}
          defaultParent={defaultParent}
          paletteId={brandkitId}
          type={'default'}
          paletteData={paletteData}
          typeName={'CAROUSELS'}
          defaultPaletteId={defaultId}
        />
    </Tab.Pane>
  );
}


const CarouselPaletteView = ({ editorSession, defaultParent, paletteId, type }) => {

  const dispatch = useDispatch();

  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });

  const parentLayout = _.get(parentWidget, 'properties.desktop.layout');

  const components = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].items`) || [] })
  const loading = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].loading`) || false })
  const fetched = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].fetched`) || false })
  const pagination = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].pagination`) || {} })
  const hasMoreItems = _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;

  useEffect(() => {
    if (paletteId && !fetched) {
      handleComponentsForPalette(0);
    }
  }, [paletteId]);

  const handleComponentsForPalette = (page) => {
    var request = {
      sort: 'order',
      order: 'ASC'
    }
    dispatch(fetchComponentsForPalette(paletteId, type, request, page, 50));
  }

  const loadMore = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }
    handleComponentsForPalette(nextPage);
  }

  const handleCreateCarousel = (data) => {
    const position = getPositionForNewWidget(editorSession, parentLayout, { width: 1200, height: 250 });
    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: CAROUSEL,
            name: "Carousel",
            properties: {
              ...data.properties,
              desktop: {
                ...data.properties.desktop,
                visible: true,
                layout: {
                  ...data.properties.desktop.layout,
                  transform: {
                    translate: `${position.x}px, ${position.y}px`,
                    rotate: "0deg"
                  }
                }
              },
              mobile: {
                ...data.properties.mobile,
                visible: true,
                layout: {
                  ...data.properties.mobile.layout,
                  transform: {
                    translate: "0px, 20px",
                    rotate: "0deg",
                  }
                }
              },
            },
            widgets: data.widgets,
            content: data.content
          },
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  return (
    <div className={styles.defaultWidgets}>
      <div className={styles.paletteTitle}>
        <h3 className={styles.label}>{type === 'brandkit' ? 'BRAND CAROUSEL' : 'CLEVERSTORY'}</h3>
        <hr className={styles.labelHighliter} />
      </div>
      <InfiniteScroll
        className={cx(styles.scrollable)}
        loading={loading}
        hasMore={hasMoreItems}
        loadMore={loadMore}
      >
        {components.map((component, index) => {
          const widgets = _.get(component, 'content.widgets', []);
          if (!widgets) {
            return null;
          }

          const widget = widgets[0];
          const icon = _.get(component, 'icon.url', null);

          return (
            <div key={index} className={styles.widget} onClick={() => handleCreateCarousel(widget)}>
              <IKImage
                className={styles.icon}
                path={icon}
              />
            </div>
          );
        })}
      </InfiniteScroll>
    </div>
  )
}

const generateCarouselData = (type) => {

  switch (type) {
    case 'basic':
      return {
        type: CAROUSEL,
        name: "Carousel",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "500px"
            },
            "stretched": false,
            "free": false,
            "arrows": {
              "enabled": true,
              "style": "MORDERN",
              "size": 15,
              "offset": 10,
              "backgroundCornerRadius": 5,
              "regular": {
                "color": {
                  "type": "color",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 198,
                  "b": 0,
                  "a": 1
                }
              },
              "hover": {
                "color": {
                  "type": "color",
                  "r": 255,
                  "g": 198,
                  "b": 0,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                }
              }
            },
            "dots": {
              "flag": false,
              "style": "DEFAULT",
              "size": 10,
              "offset": 10,
              "cornerRadius": 10,
              "defaultColor": {
                "type": "color",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "selectedColor": {
                "type": "color",
                "r": 255,
                "g": 198,
                "b": 0,
                "a": 1
              }
            },
            "transition": {
              "autoPlay": false,
              "pauseOnHover": false,
              "visibleDuration": 1,
              "speed": 1,
              "style": "FADE"
            }
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "300px"
            },
            "stretched": false,
            "free": false,
            "arrows": {
              "enabled": true,
              "style": "MORDERN",
              "size": 16,
              "offset": 0,
              "backgroundCornerRadius": 0,
              "regular": {
                "color": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "solid",
                  "r": 255,
                  "g": 198,
                  "b": 0,
                  "a": 1
                }
              },
              "hover": {
                "color": {
                  "type": "solid",
                  "r": 255,
                  "g": 198,
                  "b": 0,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                }
              }
            },
            "dots": {
              "flag": true,
              "style": "DEFAULT",
              "size": 6,
              "offset": 8,
              "cornerRadius": 10,
              "defaultColor": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "selectedColor": {
                "type": "solid",
                "r": 255,
                "g": 198,
                "b": 0,
                "a": 1
              }
            },
            "transition": null
          }
        },
        content: null,
        widgets: [{
          type: CAROUSEL_CARD,
          name: "Slide",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": null
              },
              "container": {
                "minWidth": 1200,
                "alignment": 'center'
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": "100%"
              },
              "container": {
                "minWidth": 375,
                "alignment": null
              },
              "background": null
            }
          },
        },
        {
          type: CAROUSEL_CARD,
          name: "Slide",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": null
              },
              "container": {
                "minWidth": 1200,
                "alignment": 'center'
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 79,
                  "g": 78,
                  "b": 78,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": "100%"
              },
              "container": {
                "minWidth": 375,
                "alignment": null
              },
              "background": null
            }
          },
        },
        {
          type: CAROUSEL_CARD,
          name: "Slide",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": null
              },
              "container": {
                "minWidth": 1200,
                "alignment": 'center'
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 121,
                  "g": 124,
                  "b": 124,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": "100%"
              },
              "container": {
                "minWidth": 375,
                "alignment": null
              },
              "background": null
            }
          },
        }
        ]
      }

    case 'mordern':
      return {
        type: CAROUSEL,
        name: "Carousel",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "350px"
            },
            "stretched": false,
            "free": false,
            "arrows": {
              "enabled": true,
              "style": "MORDERN",
              "size": 50,
              "offset": 10,
              "backgroundCornerRadius": 5,
              "regular": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              },
              "hover": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              }
            },
            "dots": {
              "flag": false,
              "style": "DEFAULT",
              "size": 10,
              "offset": 10,
              "cornerRadius": 10,
              "defaultColor": {
                "type": "color",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "selectedColor": {
                "type": "color",
                "r": 34,
                "g": 171,
                "b": 200,
                "a": 1
              }
            },
            "transition": {
              "autoPlay": false,
              "pauseOnHover": false,
              "visibleDuration": 1,
              "speed": 1,
              "style": "FADE"
            }
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "300px"
            },
            "stretched": false,
            "free": false,
            "arrows": {
              "enabled": true,
              "style": "MORDERN",
              "size": 16,
              "offset": 0,
              "backgroundCornerRadius": 0,
              "regular": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              },
              "hover": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              }
            },
            "dots": {
              "flag": true,
              "style": "DEFAULT",
              "size": 6,
              "offset": 8,
              "cornerRadius": 10,
              "defaultColor": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "selectedColor": {
                "type": "solid",
                "r": 255,
                "g": 198,
                "b": 0,
                "a": 1
              }
            },
            "transition": null
          }
        },
        content: null,
        widgets: [{
          type: CAROUSEL_CARD,
          name: "Slide",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": null
              },
              "container": {
                "minWidth": 1200,
                "alignment": "center"
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 234,
                  "g": 247,
                  "b": 249,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": "100%"
              },
              "container": {
                "minWidth": 375,
                "alignment": null
              },
              "background": null
            }
          },
        }
        ]
      }

    default:
      return {
        type: CAROUSEL,
        name: "Carousel",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "350px"
            },
            "stretched": false,
            "free": false,
            "arrows": {
              "enabled": true,
              "style": "MORDERN",
              "size": 50,
              "offset": 10,
              "backgroundCornerRadius": 5,
              "regular": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              },
              "hover": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              }
            },
            "dots": {
              "flag": false,
              "style": "DEFAULT",
              "size": 10,
              "offset": 10,
              "cornerRadius": 10,
              "defaultColor": {
                "type": "color",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "selectedColor": {
                "type": "color",
                "r": 34,
                "g": 171,
                "b": 200,
                "a": 1
              }
            },
            "transition": {
              "autoPlay": false,
              "pauseOnHover": false,
              "visibleDuration": 1,
              "speed": 1,
              "style": "FADE"
            }
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "300px"
            },
            "stretched": false,
            "free": false,
            "arrows": {
              "enabled": true,
              "style": "MORDERN",
              "size": 16,
              "offset": 0,
              "backgroundCornerRadius": 0,
              "regular": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              },
              "hover": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              }
            },
            "dots": {
              "flag": true,
              "style": "DEFAULT",
              "size": 6,
              "offset": 8,
              "cornerRadius": 10,
              "defaultColor": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "selectedColor": {
                "type": "solid",
                "r": 255,
                "g": 198,
                "b": 0,
                "a": 1
              }
            },
            "transition": null
          }
        },
        widgets: [{
          type: CAROUSEL_CARD,
          name: "CarouselCard",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": null
              },
              "container": {
                "minWidth": 1200,
                "alignment": 'center'
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 234,
                  "g": 247,
                  "b": 249,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": "100%"
              },
              "container": {
                "minWidth": 375,
                "alignment": null
              },
              "background": null
            }
          },
        }]
      }
  }
}

export const carousels = [
  {
    id: 'basic_Carousel',
    name: 'Basic Carousel',
    render: () => {
      return <img className={cx(styles.menu, styles.basic)} src="/images/palette/carousel/basicCarousel.png" />
    },
    data: generateCarouselData('basic')
  },
  {
    id: 'standard_Carousel',
    name: 'Standard Carousel',
    render: () => {
      return <img className={cx(styles.menu, styles.basic)} src="/images/palette/carousel/mordernCarousel.png" />
    },
    data: generateCarouselData('mordern')
  }
]